import { render } from "./ChallengesView.vue?vue&type=template&id=6fca7d70"
import script from "./ChallengesView.vue?vue&type=script&lang=js"
export * from "./ChallengesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__